import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import TabComp from './tab-comp';
import { useState } from 'react';

const SaveMoney: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('SaveMoney');

    // 管理当前打开的tab，null表示没有tab打开
    const [openTabIndex, setOpenTabIndex] = useState<number | null>(null);

    console.log(styles.SaveMoney);

    const items = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
    ];

    return (
        <div className={styles.SaveMoney}>
            <EcoSectionCommon title={t('title')} desc={t('desc')} />

            <div className="content-box eco-content">
                {items.map((item, index) => (
                    <div className="item" key={index}>
                        <div className="title">{item.title}</div>
                        <div className="desc">{item.desc}</div>
                    </div>
                ))}
            </div>

            <div className="img-wrapper eco-content">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1750919466377/%E6%B7%B7%E9%80%86ultra%E5%8E%9F%E7%90%86%E5%9B%BE%201.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1750919466530/%E6%B7%B7%E9%80%86%E5%8E%9F%E7%90%86%E5%9B%BE%201.jpg"
                />
                <TabComp
                    className="tab3"
                    title={t('tab3_title')}
                    contentTitle={t('tab3_title')}
                    contentDesc={t('tab3_desc')}
                    isOpen={openTabIndex === 2}
                    onOpen={() => setOpenTabIndex(2)}
                    onClose={() => setOpenTabIndex(null)}
                />

                <TabComp
                    className="tab2"
                    title={'STREAM Ultra'}
                    contentTitle={t('tab2_title')}
                    contentDesc={t('tab2_desc')}
                    isOpen={openTabIndex === 1}
                    onOpen={() => setOpenTabIndex(1)}
                    onClose={() => setOpenTabIndex(null)}
                />
                <TabComp
                    className="tab1"
                    title={t('tab1_title')}
                    contentTitle={t('tab1_title')}
                    contentDesc={t('tab1_desc')}
                    isOpen={openTabIndex === 0}
                    onOpen={() => setOpenTabIndex(0)}
                    onClose={() => setOpenTabIndex(null)}
                />

                <div className="smart-meter">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1752548428063/small.png" />
                </div>
            </div>

            <div className="footer-desc eco-content">{t('footer_desc')}</div>
        </div>
    );
};

export default SaveMoney;
